import { Cadastro } from "./Cadastro";

export default Cadastro;